/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ theme, activeTab, setActiveTab, products, onAddToCart, onOpenProduct }) => {
  return (
    <section className="container mx-auto px-4 sm:px-6 py-12" dir="rtl">
      {/* Header & Tabs */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-10 gap-6">
        {/* شريط التبويبات */}
        <div className="flex bg-gray-100/80 p-1.5 rounded-[2rem] shadow-inner">
          {[
            { id: 'all', label: 'كل المنتجات' },
            { id: 'bestseller', label: 'الأكثر مبيعاً' },
            { id: 'new', label: 'المنتجات الجديدة' }
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-8 py-2.5 rounded-[1.8rem] text-sm font-bold transition-all duration-300 ${activeTab === tab.id
                ? `bg-white shadow-md text-gray-900 scale-105`
                : 'text-gray-400 hover:text-gray-600'
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* عنوان القسم */}
        <h2 className="text-2xl font-black text-gray-800 relative">
          منتجات مميزة
          <span className={`absolute -bottom-2 right-0 w-12 h-1 ${theme.bg} rounded-full`}></span>
        </h2>
      </div>

      {/* Grid المنتجات مع أنيميشن عند التغيير */}
      {products.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8 transition-all duration-500">
          {products.map((product, idx) => (
            <div
              key={product.id || idx}
              className="animate-fadeInScale w-full"
              style={{ animationDelay: `${idx * 0.05}s` }} // تأثير ظهور تتابعي
            >
              <ProductCard
                product={product}
                theme={theme}
                onAddToCart={onAddToCart}
                onOpenProduct={onOpenProduct}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="py-20 text-center text-gray-400 font-bold border-2 border-dashed border-gray-100 rounded-[2.5rem]">
          لا توجد منتجات في هذا القسم حالياً
        </div>
      )}

      {/* إضافة الأنماط الحركية */}
      <style>{`
        @keyframes fadeInScale {
          from { 
            opacity: 0; 
            transform: scale(0.9) translateY(20px); 
          }
          to { 
            opacity: 1; 
            transform: scale(1) translateY(0); 
          }
        }
        .animate-fadeInScale {
          animation: fadeInScale 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
    </section>
  );
};

export default ProductGrid;
